<script setup>
import { getSmartPlatform } from '@weathernews/btos-javascript-modules/src/wniutil/common.js'

const route = useRoute()
const mapName = 'okinawa'
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isMobile = ref(false)
if (route.path !== `/${mapName}/`) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('pref', getFullPrefectureName(mapName))
const breadCrumbList = getBreadCrumb(mapName)
const [pickupLivecamList, prefLivecamList] = await Promise.all([
  useFetch('/api/livecam/pickuplist', { query: { target: mapName } }),
  useFetch('/api/livecam/pointlist', { query: { target: mapName } })
]).then((responses) => responses.map((res) => res.data))
const { sortPickupLivecamList, sortRemainingPreflist } = sortPrefLivecamData(pickupLivecamList.value, prefLivecamList.value)
onMounted(() => {
  isMobile.value = getSmartPlatform() !== ''
})
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
      :area="areaToPrefTable.find(({ key }) => key === mapName).name"
      :area-roma="mapName"
    >
      <template v-if="!isMobile">
        <div class="frame">
          <CommonPageTitle :title="`${getPrefectureName(mapName)}のライブカメラ`" />
          <LivecamList :list="sortPickupLivecamList" />
        </div>
      </template>
      <template #main-bottom>
        <template v-if="isMobile">
          <div class="frame">
            <CommonPageTitle :title="`${getPrefectureName(mapName)}のライブカメラ`" />
            <LivecamList :list="sortPickupLivecamList" />
            <div
              id="ads-btf2-sp"
              class="ads-btf2-sp"
            />
          </div>
        </template>
        <LivecamPointList
          v-if="sortRemainingPreflist.length!==0"
          :list="sortRemainingPreflist"
        />
        <TopicList />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
.ads-btf2-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
